<section class="panel"><h2>Administración de usuarios</h2>
<sr-admin-data-table label="Usuarios que han ingresado al sistema" [rows]="rows()" [columns]="columns" [actions]="actions" (action)="open($event)" />
@if (selected) { <sr-gestionar-usuario [user]="selected" [readOnly]="readOnly" (closed)="selected=null" /> }
</section>